import { roundUp } from '@/services/global';
import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

export const useCartAction = (
  type: 'add_to_cart' | 'remove_from_cart',
  item: ICartProduct | IProduct,
  quantity: number,
) => {
  if (!window.gtag) return;

  window.gtag('event', type, {
    currency: 'BRL',
    value: roundUp(item.price * quantity),
    items: [
      {
        item_id: item.product_id,
        item_name: item.title,
        quantity,
      },
    ],
  });
};
